export default "__VITE_ASSET__6edcc402__"